import i18n from 'i18next';

// Server-side PDF regeneration must render a form in the language its PDF was
// made in, so every create-form/edit-form request stamps the UI language the
// browser is rendering in at save time (e.g. CreateOrientationFormPDF.js),
// reduced to a lowercase 2-letter code ('fi', 'et', ...).
export default function getPdfLanguage() {
  return (i18n.language || 'fi').split(/[-_]/)[0].toLowerCase();
}
